import { ThemeEvents } from '@theme/events';

class ProductWhatsAppAsk extends HTMLElement {
  #link = null;

  connectedCallback() {
    this.#link = this.querySelector('a');
    if (!this.#link) return;

    this.#updateLink();

    const section = this.closest('.shopify-section');
    section?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section');
    section?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #onVariantUpdate = (event) => {
    const variant = event.detail?.resource;
    if (variant?.title) {
      this.dataset.variantTitle = variant.title;
    }

    const priceText = this.closest('.shopify-section')
      ?.querySelector('product-price [ref="priceContainer"], .price')
      ?.textContent?.trim();

    if (priceText) {
      this.dataset.variantPrice = priceText;
    }

    this.#updateLink();
  };

  #buildMessage() {
    const lines = ['Merhaba, aşağıdaki ürün hakkında soru sormak istiyorum:', ''];

    if (this.dataset.productTitle) {
      lines.push(`Ürün: ${this.dataset.productTitle}`);
    }

    const variantTitle = this.dataset.variantTitle || '';
    const defaultTitle = this.dataset.defaultVariantTitle || '';
    if (variantTitle && variantTitle !== defaultTitle) {
      lines.push(`Varyant: ${variantTitle}`);
    }

    if (this.dataset.variantPrice) {
      lines.push(`Fiyat: ${this.dataset.variantPrice}`);
    }

    if (this.dataset.productUrl) {
      lines.push(`Link: ${this.dataset.productUrl}`);
    }

    return lines.join('\n');
  }

  #updateLink() {
    const waNumber = this.dataset.waNumber;
    if (!waNumber || !this.#link) return;

    this.#link.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(this.#buildMessage())}`;
  }
}

if (!customElements.get('product-whatsapp-ask')) {
  customElements.define('product-whatsapp-ask', ProductWhatsAppAsk);
}
